export function PageLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="page-loader">
      <div className="page-loader__spinner" role="status" aria-label={label} />
    </div>
  );
}
